// Vue
import {Component, Prop, Vue} from 'vue-property-decorator'
// Template
import template from './template.vue'
import {HttpService} from "../../../services/HttpService";
import axios from 'axios'
import {CommunicationModuleMessageInput} from "./communication_module_message_input/CommunicationModuleMessageInput";
import {CommunicationModuleMessageBlock} from "./communication_module_message_block/CommunicationModuleMessageBlock";

interface Message {
    id: string,
    children: Message[]
    parentId: string
}

interface Recipient {

}

@Component({
    name: 'CommunicationModule',
    mixins: [
        template,
    ],
    components: {
        CommunicationModuleMessageBlock,
        CommunicationModuleMessageInput,
    }
})
export class CommunicationModule extends Vue {

    private readonly http: HttpService = HttpService.instance

    @Prop({default: true})
    private subjectOptional!:boolean

    @Prop()
    private loadMessageUrl!: string

    @Prop({default: 'GET'})
    private loadMessageHttpMethod!: string

    @Prop()
    private loadRecipientsUrl!: string

    @Prop({default: 'GET'})
    private loadRecipientsUrlHttpMethod!: string

    @Prop()
    private sendMessageUrl!: string

    @Prop({default: 'POST'})
    private sendMessageHttpMethod!: string

    @Prop({default: () => []})
    private additionalLoadMessagesParameter!: any[]

    @Prop({default: () => []})
    private additionalLoadRecipientsParameter!: any[]

    @Prop({default: () => []})
    private additionalSendMessageParameter!: any[]

    @Prop({default: 'Empfänger Liste'})
    private labelRecipientListField!: string

    @Prop({default: 'Nachricht'})
    private labelMessageField!: string

    @Prop({default: 'Betreff'})
    private labelSubjectField!: string

    @Prop({default: 'Anhänge'})
    private labelAttachmentField!: string

    @Prop({default: 'antworten'})
    private answerButtonText!: string

    @Prop({default: 'entfernen'})
    private removeAttachmentLinkText!: string

    @Prop({default: 'Absenden'})
    private submitButtonText!: string

    @Prop({default: 'Abbrechen'})
    private abortButtonText!: string

    @Prop({default: 'Neue Nachrichten laden'})
    private labelRefreshMessages!: string

    @Prop({default: () => ['image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint']})
    private supportedFileTypes!: string[]

    @Prop({default: 4194304})
    private maxFileSize!: number

    @Prop()
    private errorTooLarge!: string

    @Prop()
    private errorUnsupportedType!: string

    @Prop({default: 'de'})
    private locale!: string

    @Prop({default: true})
    private isAllowedToSendNewMessages!: boolean

    private messages: Message[] = []

    private recipientList: Recipient[] = []

    get hierarchicalMessages() {
        let map = {}, node, roots: Message[] = [], i, messages = JSON.parse(JSON.stringify(this.messages))

        for (i = 0; i < messages.length; i += 1) {
            map[messages[i].id] = i;
            messages[i].children = []
        }

        for (i = 0; i < messages.length; i += 1) {
            node = messages[i];
            if (node.parentId !== null && node.parentId !== "null" && node.parentId !== "0") {
                messages[map[node.parentId]].children.push(node);
            } else {
                roots.push(node);
            }
        }

        return roots;
    }

    created() {
        this.refresh();
    }

    protected async refresh() {
        let additionalLoadMessagesParameter = this.additionalLoadMessagesParameter;
        additionalLoadMessagesParameter['iso'] = this.locale;

        let additionalLoadRecipientsParameter = this.additionalLoadRecipientsParameter;
        additionalLoadRecipientsParameter['iso'] = this.locale;

        if (this.loadMessageHttpMethod == 'GET') {
            let response = await axios.get<Message[]>(
                this.loadMessageUrl,
                Object.assign({}, HttpService.defaultConfig, {params: additionalLoadMessagesParameter})
            )
            this.messages = response.data
        } else if (this.loadMessageHttpMethod == 'POST') {
            let response = await axios.post<Message[]>(
                this.loadMessageUrl,
                additionalLoadMessagesParameter,
                Object.assign({}, HttpService.defaultConfig, {})
            )
            this.messages = response.data
        }

        if (this.loadRecipientsUrlHttpMethod == 'GET') {
            let response = await axios.get<Recipient[]>(
                this.loadRecipientsUrl,
                Object.assign({}, HttpService.defaultConfig, {params: additionalLoadRecipientsParameter})
            )
            this.recipientList = response.data
        } else if (this.loadRecipientsUrlHttpMethod == 'POST') {
            let response = await axios.post<Recipient[]>(
                this.loadRecipientsUrl,
                additionalLoadRecipientsParameter,
                Object.assign({}, HttpService.defaultConfig, {})
            )
            this.recipientList = response.data
        }
    }

    protected async sendMessage(parentId, subject, text, recipient, attachments) {
        if (subject && text) {
            let formData = new FormData();
            if (recipient) {
                formData.append('recipient', recipient)
            }
            formData.append('message', text);
            formData.append('subject', subject);
            formData.append('iso', this.locale);
            if (parentId) {
                formData.append('parentId', parentId)
            }

            if (this.additionalSendMessageParameter) {
                for (var k in this.additionalSendMessageParameter){
                    if (this.additionalSendMessageParameter.hasOwnProperty(k)) {
                        formData.append(k, this.additionalSendMessageParameter[k]);
                    }
                }
            }

            if (attachments && attachments.length) {
                for (var i = 0; i < attachments.length; i++) {
                    formData.append('attachment[' + i+ ']', attachments[i]);
                }
            }

            let response = await axios.post<Message>(
                this.sendMessageUrl,
                formData
            )

            this.messages.push(response.data);
        }
    }
}